import React from 'react';
import FlashSaleCountdown from './FlashSaleCountdown';

const FlashSale = ({
  dateTimer,
  title = 'Hot Deals',
}: {
  dateTimer?: string | Date;
  title?: string;
}) => {
  return (
    <section className="page-header pb-0">
      <div className="container">
        <div className="page-header__content">
          <h2 className="title-color fw-medium mb-2 fs-1">{title}</h2>

          <FlashSaleCountdown targetDate={dateTimer} />
        </div>
      </div>
    </section>
  );
};

export default FlashSale;
